/**
 * Whether to offer the first-run tour (A-25): on each visit until the visitor
 * completes it or ticks "Don't show again", and never over a deep link, which
 * means they came for something specific. Stored in localStorage.
 */

export type TourPreference = "completed" | "dismissed";

/** Exported for tooling that should arrive as a returning visitor (gen:thumbs). */
export const TOUR_STORAGE_KEY = "kn.tour";

export function shouldOfferTour(input: {
  readonly preference: TourPreference | null;
  readonly deepLinked: boolean;
}): boolean {
  return input.preference === null && !input.deepLinked;
}

export function readTourPreference(win: Window): TourPreference | null {
  try {
    const value = win.localStorage.getItem(TOUR_STORAGE_KEY);
    return value === "completed" || value === "dismissed" ? value : null;
  } catch {
    return null; // Storage can be unavailable (privacy modes): offer, but don't remember.
  }
}

export function writeTourPreference(win: Window, preference: TourPreference): void {
  try {
    win.localStorage.setItem(TOUR_STORAGE_KEY, preference);
  } catch {
    // Not remembered; the offer comes back next visit.
  }
}
